"use client";
import { useState, useRef, useEffect } from "react";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from "@/app/styles/hamburgerMenu.module.scss";
import contactData from "@/data/contact";
const HamburgerMenu = ({ color }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // ปิดเมนูเมื่อคลิกนอกพื้นที่
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false); // ปิดเมนู
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <main className={styles.hamburgerMenu} ref={menuRef}>
      {!isOpen && (
        <button className={styles.menuButton} onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} />
        </button>
      )}

      {isOpen && (
        <nav className={styles.menu}>
          <button className={styles.menuButton} onClick={toggleMenu}>
            <FontAwesomeIcon
              icon={faTimes}
              style={{ "--nav-color": `${color}` }}
            />
          </button>
          <ul>
            <li>
              <Link href="/about" onClick={toggleMenu}>
                ABOUT
              </Link>
            </li>
            <li>
              <Link href="/services" onClick={toggleMenu}>
                SERVICES
              </Link>
            </li>
            <li>
              <Link href="/projects" onClick={toggleMenu}>
                PROJECTS
              </Link>
            </li>
            <li>
              <Link href="/warranty" onClick={toggleMenu}>
                WARRANTY
              </Link>
            </li>
            <li>
              <Link
                href={`https://line.me/R/ti/p/${contactData.lineID}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                CONTACT US
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </main>
  );
};

export default HamburgerMenu;
